import styles from "./HeaderDesktop.module.css";
import { HoverPopover } from "src/components/ui-components/HoverPopover/HoverPopover";
import { TooltipInteractive } from "src/components/ui-components/Tooltip/TooltipInteractive";
import { Button } from "src/components/ui-components/Button/Button";
import { AnchorButtonTextOnly } from "src/components/ui-components/ButtonTextOnly/AnchorButtonTextOnly";
import { IconPlusSquare } from "src/components/ui-components/Icons/IconPlusSquare";
import { HeaderCreateMenu } from "./HeaderCreateMenu";
import { CreateDashboardDialog } from "src/components/page-components/DashboardPage/create";
import { InviteMemberDialogContent } from "shared/InviteMember/InviteMemberDialog";
import { DataUploadModalContent } from "../../DataUpload/DataUploadModalContent";
import { ModalWithoutTrigger } from "src/components/ui-components/Modal";

import { useState } from "react";
import { useSession } from "src/components/session/session";
import { useActiveContext } from "shared/ContextSwitcher/store";

export function HeaderCreateButton() {
  const session = useSession();
  const activeContext = useActiveContext();

  const [isCreateDashboardDialogOpen, setIsCreateDashboardDialogOpen] =
    useState(false);
  const [isAddMembersDialogOpen, setIsAddMembersDialogOpen] = useState(false);
  const [isDataUploadModalOpen, setIsDataUploadModalOpen] = useState(false);

  const canNotEdit = activeContext?.permissions.canEditContent === false;

  if (!session || activeContext === undefined || canNotEdit) {
    return (
      <TooltipInteractive
        position="below-align-left"
        content={() =>
          canNotEdit ? (
            <>
              You're a Viewer of this team. <br />
              Ask an admin to promote you to the Editor role,
              <br />
              or switch to a different workspace.
            </>
          ) : (
            <>
              Sign up or log in to start creating.{" "}
              <AnchorButtonTextOnly
                theme="secondary"
                size="M"
                href="/auth/login"
              >
                Get started
              </AnchorButtonTextOnly>
              .
            </>
          )
        }
      >
        <Button
          theme="primary-light"
          size="M"
          className={styles.createButton}
          disabled
        >
          <IconPlusSquare />
          <div className={styles.createText}>Create</div>
        </Button>
      </TooltipInteractive>
    );
  }

  return (
    <>
      <HoverPopover
        position="below-align-left"
        content={({ close }) => (
          <HeaderCreateMenu
            session={session}
            activeContext={activeContext}
            setIsCreateDashboardDialogOpen={setIsCreateDashboardDialogOpen}
            setIsAddMembersDialogOpen={setIsAddMembersDialogOpen}
            setIsDataUploadModalOpen={setIsDataUploadModalOpen}
            close={close}
          />
        )}
      >
        <Button theme="primary-light" size="M" className={styles.createButton}>
          <IconPlusSquare />
          <div className={styles.createText}>Create</div>
        </Button>
      </HoverPopover>

      <CreateDashboardDialog
        isOpen={isCreateDashboardDialogOpen}
        close={() => setIsCreateDashboardDialogOpen(false)}
        redirect={true}
      />

      {activeContext.type === "team" && (
        <ModalWithoutTrigger
          label="Invite more people"
          size="M"
          isOpen={isAddMembersDialogOpen}
          onDismiss={() => setIsAddMembersDialogOpen(false)}
          content={
            <InviteMemberDialogContent
              onDismiss={() => setIsAddMembersDialogOpen(false)}
              team={activeContext}
              session={session}
              onInvite={() => {}}
            />
          }
        />
      )}

      <ModalWithoutTrigger
        label="Upload a dataset"
        size="M"
        content={
          <DataUploadModalContent
            onDismiss={() => setIsDataUploadModalOpen(false)}
          />
        }
        isOpen={isDataUploadModalOpen}
        onDismiss={() => setIsDataUploadModalOpen(false)}
      />
    </>
  );
}
